/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification General Alert Icon component.
 */
export const NotificationGeneralAlertIcon = ({size, color = dlsColor('grey1')}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <ThemeIconProvider name='NotificationGeneralAlertIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <rect x={1}
          y={12.2}
          width={15.8392}
          height={15.8392}
          rx={0.5}
          transform='rotate(-45 1 12.2)'
          stroke={iconColor}
          strokeWidth={1.5} />
        <path d='M12.3389 13.5276L12.3389 6.86824'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M12.3391 17.1958L12.3391 15.7715'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
      </svg>
    )} />
  );
};
